import { CommonModule } from '@angular/common';
import { Component, input, model } from '@angular/core';
import { map, takeWhile, timer } from 'rxjs';

@Component({
  selector: 'app-countdown',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './countdown.component.html',
  styleUrl: './countdown.component.scss'
})
export class CountdownComponent {
  endTime = model.required<boolean>();
  startTime = input.required<number>();
  timer!: number;

  constructor() {}

  ngOnInit(): void {
    this.startTimer();
  }

  private startTimer(): void {
    timer(0, 1000)
      .pipe(
        map(n => (this.startTime() - n) * 1000),
        takeWhile((n: number) => n >= 0),
      )
      .subscribe({
        next: timer => (this.timer = timer),
        complete: () => this.endTime.set(true),
      });
  }
}
